import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";
import { Button, Group } from "@/components/ui";

interface Props {
  todosConfirmados: boolean;
  soloLectura: boolean;
  onVolver: () => void;
  onContinuar: () => void;
}

/**
 * Botonera del paso · Volver siempre, Continuar deshabilitado mientras
 * algún CFDI tenga prorrateo no confirmado.
 */
export function ProrrateoMultipleActions({ todosConfirmados, soloLectura, onVolver, onContinuar }: Props) {
  return (
    <Group justify="space-between" className="mt-1">
      <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={onVolver}>
        Regresar a Proveedor
      </Button>
      {!soloLectura && (
        <Button rightSection={<IconArrowRight size={14} />} disabled={!todosConfirmados} onClick={onContinuar}>
          {todosConfirmados ? "Continuar a documentos" : "Confirma todos los prorrateos para continuar"}
        </Button>
      )}
    </Group>
  );
}
